import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M.5 21.5h23M.5 13.5l10-4M2.5 12.719V21.5M9 2.5l14.5 9M21.5 10.281V21.5M18.5 8.407V5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4.641M19 21.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5M16.5 17.5v4" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "15.001",
  cy: "11.5",
  r: "1.5"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M8 21.5a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5H5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5M10.5 3.453V21.5" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { toRefs } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    size: { default: 12 }
  },
  setup(__props: any) {

const props = __props as { size: number }

    

    const { size } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _unref(size),
    height: _unref(size),
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, _hoisted_5, 8, _hoisted_1))
}
}

})